import { SMTPLogTable } from './SMTPLogTable'

export const SMTPLogView = () => {
  return (
    <div className='flex flex-col md:w-full w-[calc(100%+2.5rem)] md:mx-0 mx-[-1.25rem] bg-white rounded-[1.25rem] shadow-navbar p-4'>
      <SMTPLogTable />
    </div>
  )
}
